export default "__VITE_ASSET__CkQdQiYO__"